import { render } from "./blogDetails.vue?vue&type=template&id=406a9fe6"
import script from "./blogDetails.vue?vue&type=script&lang=js"
export * from "./blogDetails.vue?vue&type=script&lang=js"

import "./blogDetails.vue?vue&type=style&index=0&id=406a9fe6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__